import fondsManage from "@/mods/setting/detailView/fondsManage";
import schemeDetection from "@/mods/setting/detailView/schemeDetection";
export default {
  fondsManage,
  schemeDetection,
};
